import type { PropsWithChildren } from 'react';
import { configureWallets, Web3ModalProvider } from '../wallet-connect';
import { WagmiProvider } from 'wagmi';
import { cratD2CTestnet, wagmiConfig } from '../wagmi';
import { QueryClient as TQueryClient, QueryClientProvider as TQueryClientProvider } from '@tanstack/react-query'
import ConnectWalletModal from "../../components/WalletModal";

const wallets = configureWallets({
  walletconnectProjectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID as string,
});

const tQueryClient = new TQueryClient()

export const WalletProvider = ({ children }: PropsWithChildren) => {
  return (
    <WagmiProvider config={wagmiConfig} reconnectOnMount={false}>
      <TQueryClientProvider client={tQueryClient}>
        <Web3ModalProvider chains={wagmiConfig.chains} wallets={wallets} chainId={cratD2CTestnet.id}>
          <ConnectWalletModal wallets={wallets} />
          {children}
        </Web3ModalProvider>
      </TQueryClientProvider>
    </WagmiProvider>
  );
};
